export var OrgaoExpedidorEnum;
(function (OrgaoExpedidorEnum) {
    OrgaoExpedidorEnum["DTC"] = "DTC";
    OrgaoExpedidorEnum["DTOP"] = "DTOP";
    OrgaoExpedidorEnum["DTMC"] = "DTMC";
    OrgaoExpedidorEnum["SESMARIA"] = "SESMARIA";
    OrgaoExpedidorEnum["CODEMAT"] = "CODEMAT";
    OrgaoExpedidorEnum["INTERMAT"] = "INTERMAT";
})(OrgaoExpedidorEnum || (OrgaoExpedidorEnum = {}));
(function (OrgaoExpedidorEnum) {
    OrgaoExpedidorEnum.mapDescricao = new Map([
        [OrgaoExpedidorEnum.DTC, 'Departamento de Terras e Colonização'],
        [OrgaoExpedidorEnum.DTOP, 'Departamento de Terras e Obras Públicas'],
        [OrgaoExpedidorEnum.DTMC, 'Departamento de Terras Minas e Colonização'],
        [OrgaoExpedidorEnum.SESMARIA, 'É o nome época dos portugueses.(Não é sigla)'],
        [OrgaoExpedidorEnum.CODEMAT, 'Companhia de Desenvolvimento do Estado do Mato Grosso'],
        [OrgaoExpedidorEnum.INTERMAT, 'Instituto de Terras de Mato Grosso'],
    ]);
    OrgaoExpedidorEnum.mapDescricaoWithSigla = new Map([
        [OrgaoExpedidorEnum.DTC, 'DTC - Departamento de Terras e Colonização'],
        [OrgaoExpedidorEnum.DTOP, 'DTOP - Departamento de Terras e Obras Públicas'],
        [OrgaoExpedidorEnum.DTMC, 'DTMC - Departamento de Terras Minas e Colonização'],
        [OrgaoExpedidorEnum.SESMARIA, 'SESMARIA - É o nome época dos portugueses.(Não é sigla)'],
        [OrgaoExpedidorEnum.CODEMAT, 'CODEMAT - Companhia de Desenvolvimento do Estado do Mato Grosso'],
        [OrgaoExpedidorEnum.INTERMAT, 'INTERMAT - Instituto de Terras de Mato Grosso'],
    ]);
    function getDescricao(key) {
        return OrgaoExpedidorEnum.mapDescricao.get(key);
    }
    OrgaoExpedidorEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        OrgaoExpedidorEnum.mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    OrgaoExpedidorEnum.getOptions = getOptions;
    function getOptionsWithSigla() {
        var list = [];
        OrgaoExpedidorEnum.mapDescricaoWithSigla.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    OrgaoExpedidorEnum.getOptionsWithSigla = getOptionsWithSigla;
})(OrgaoExpedidorEnum || (OrgaoExpedidorEnum = {}));
